import { render, staticRenderFns } from "./recordDetail.vue?vue&type=template&id=7fd69924&scoped=true"
import script from "./recordDetail.vue?vue&type=script&lang=js"
export * from "./recordDetail.vue?vue&type=script&lang=js"
import style0 from "./recordDetail.vue?vue&type=style&index=0&id=7fd69924&prod&lang=less&scoped=true"
import style1 from "./recordDetail.vue?vue&type=style&index=1&id=7fd69924&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd69924",
  null
  
)

export default component.exports